import { Component, EventEmitter, Input, Output } from '@angular/core';
import type { InnogyComponentRendering } from '@core/jss-models';
import { CardComponent } from '@legacy/common-ui-partials';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'wl-progressive-form-step-card',
  templateUrl: './progressive-form-step-card.component.html',
  styleUrls: [
    './progressive-form-step-card.component.ed.scss',
    './progressive-form-step-card.component.essent.scss',
  ],
  standalone: true,
  imports: [
    CardComponent,
    AutomationIdDirective,
    CSCaptureDirective,
    FaIconComponent,
  ],
})
export class ProgressiveFormStepCardComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering: InnogyComponentRendering | undefined;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() title = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() subtitle = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() changeButtonText = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() formStepId?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() canBeEdited?: boolean;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() isActive?: boolean;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() isValid?: boolean;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() isSubmitted?: boolean;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() hideSummary?: boolean;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() isReadonly?: boolean;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showWhenFutureStep?: boolean;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() isFutureStep?: boolean;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showSeperator?: boolean;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showProgression?: boolean;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() currentStep?: number;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() totalSteps?: number;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() isSkipped?: boolean;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showWhenSkipped = false;
  @Output() setEditingFormStep = new EventEmitter<void>();

  get isBodyShown(): boolean | undefined {
    return (
      this.isActive || (this.isValid && this.isSubmitted && !this.hideSummary)
    );
  }

  get isSeperatorShown(): boolean | undefined {
    return this.showSeperator && (this.isBodyShown || this.isReadonly);
  }

  private get hideSkipped(): boolean {
    return !!this.isSkipped && !this.showWhenSkipped;
  }

  private get hideFutureStep(): boolean {
    return !this.showWhenFutureStep && !!this.isFutureStep;
  }

  get showStep(): boolean {
    return !this.hideSkipped && !this.hideFutureStep;
  }

  get changeButtonAutomationId(): string {
    return this.formStepId + '-change-button';
  }

  get progression() {
    return this.currentStep && this.showProgression
      ? `(${this.currentStep}/${this.totalSteps})`
      : '';
  }
}
